/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { RouterModule } from '@angular/router';
//import { KALEIDA_UK_DATE_FORMATS } from 'app/app.module';
import { AppMaterialModule } from 'app/core/app-material/app-material.module';
import { SharedModule } from 'app/shared/shared.module';
import { ExternalRaiseDefectFormComponent } from './external-raise-defect-form.component';
import { EditorModule } from '@tinymce/tinymce-angular';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    AppMaterialModule,

  ],
  declarations: [
    ExternalRaiseDefectFormComponent,
  ],
  exports: [ExternalRaiseDefectFormComponent],
  // entryComponents: [
  //   ExternalRaiseDefectFormComponent,
  // ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // TODO: [Development][dpb][2024-10-17] Review whether these date formats needed in this module
//    { provide: MAT_DATE_FORMATS, useValue: KALEIDA_UK_DATE_FORMATS },
  ],
})
export class ExternalRaiseDefectModule {}
